module.exports = __webpack_public_path__ + "img/2012-08-18 13.15.09.0d792859.jpg";